import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { RunStrategy } from "multitool-sdk-core";

interface StrategyProps {
  allowed: RunStrategy[];
  onChange: (s: RunStrategy[]) => void;
}

const Strategy: React.FC<StrategyProps> = ({ allowed, onChange }) => {
  return (
    <RadioGroup
      row
      name="strategy"
      defaultValue={allowed[0]}
      onChange={(e) => {
        onChange([e.target.value as RunStrategy]);
      }}
    >
      {allowed.map((s) => (
        <FormControlLabel
          key={s.toString()}
          value={s.toString()}
          control={<Radio />}
          label={s.toString()}
        />
      ))}
    </RadioGroup>
  );
};

export default Strategy;
